// Port of PROTO join.html (BRIEF P4). Shared PAGE_CSS rules used here
// (.prose, .narrow, .quote, hr.rule-ink, .wrap, .section) already live in
// ../../styles/site.css — this page needs no CSS of its own (see
// JoinPage.css and build-plan R6).
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Opener } from '../Opener.js';
import { useReveal } from '../motion.js';
import './JoinPage.css';

export function JoinPage() {
  const ref = useRef<HTMLDivElement | null>(null);
  useReveal(ref);

  return (
    <div className="jn-page" ref={ref}>
      <Opener lines={['Join our', 'ranks']} />
      <section className="wrap section">
        <div className="prose big narrow" data-reveal>
          <p>
            Interested in becoming a clan member? We’re committed to ensuring it’s a great fit for both you and
            us. That’s why we believe in being transparent upfront about our values, expectations, and what it
            truly means to be part of our clan. This way, everyone can feel confident that they’re joining a
            community that aligns with their own goals, values and ideals.
          </p>
          <h2>Safe enough to try</h2>
          <p>
            Of course, the proof of the pudding is in the eating. If it turns out that we’re not as compatible as
            we hoped, we can part ways smoothly. It’s useful to be clear upfront about how to handle such
            situations if they arise. In the ‘<Link to="/leaving">How to End Your Clan Membership</Link>’
            section, we’ve outlined how we can separate on good terms. Knowing that we can part on good terms
            makes it easier to take a leap of faith. We believe in offering trust by default, right from the
            start.
          </p>
        </div>
        <hr className="rule-ink" />
        <p className="quote" data-reveal>
          Rules may bend and break, hence we don’t do rules. Yet <Link to="/code">the pirate’s code</Link> is ever
          honored with steadfast resolve.
        </p>
      </section>
    </div>
  );
}
